// @ts-nocheck
import * as React from "react";

// 오프라인 폴백 화면 — 서비스워커가 네트워크 실패 시 캐시에서 서빙한다.
// API를 호출하지 않아야 오프라인에서도 렌더된다(셸: design.js + design-tokens.css 만 의존).
export function Offline() {
  const retry = () => location.reload();
  return (
    <div style={{
      minHeight: "100vh", display: "grid", placeItems: "center",
      background: "var(--bg, #FAF6EE)", padding: 24,
      fontFamily: '"Pretendard Variable", Pretendard, system-ui, sans-serif',
    }}>
      <div style={{ textAlign: "center", maxWidth: 360 }}>
        <div style={{
          width: 88, height: 88, margin: "0 auto 24px", borderRadius: 24,
          background: "var(--orange-500, #E8825B)", display: "grid", placeItems: "center",
          boxShadow: "0 10px 30px rgba(232,130,91,.35)",
        }}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none"
               style={{ fontSize: 48 }} aria-hidden="true">
            <path d="M12 20s-7-4.5-7-9a4 4 0 0 1 7-2.6A4 4 0 0 1 19 11c0 4.5-7 9-7 9z"
                  fill="#fff"/>
          </svg>
        </div>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: "var(--ink-1, #2A241F)", margin: "0 0 8px" }}>
          오프라인 상태예요
        </h1>
        <p style={{ fontSize: 15, lineHeight: 1.6, color: "var(--ink-3, #8A8079)", margin: "0 0 28px" }}>
          인터넷 연결이 끊겼습니다.<br />연결을 확인한 뒤 다시 시도해 주세요.
        </p>
        <button onClick={retry} style={{
          appearance: "none", border: "none", cursor: "pointer",
          background: "var(--orange-500, #E8825B)", color: "#fff",
          fontSize: 16, fontWeight: 600, padding: "14px 28px", borderRadius: 14,
          fontFamily: "inherit",
        }}>
          다시 시도
        </button>
      </div>
    </div>
  );
}
